
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.0.0 (NJsonSchema v10.1.24.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
        //this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getAllUsers(count?: number | null | undefined, skip?:number | null | undefined, key?: string | null | undefined): Observable<OutputUserDto> {
        let url_ = this.baseUrl + "/api/Account/api/Account/GetAllUsers?";
        if (count !== undefined && count !== null)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
            if (skip !== undefined && skip !== null)
                url_ += "skip=" + encodeURIComponent("" + skip) + "&";
                if (key !== undefined && key !== null && key !== '')
                    url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = { 
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(<any>response_);
                } catch (e) {
                    return <Observable<OutputUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutputUserDto>><any>_observableThrow(response_);
        }));
    }
    getIpAddress(): Observable<any> {
        return this.http.get("http://api.ipify.org/?format=json");
    }
    protected processGetAllUsers(response: HttpResponseBase): Observable<OutputUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OutputUserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutputUserDto>(<any>null);
    }

    post(input: InputUserDto): Observable<User> {
        let url_ = this.baseUrl + "/api/Account/api/Account/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<User>><any>_observableThrow(e);
                }
            } else
                return <Observable<User>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = User.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(<any>null);
    }

    resetPassword(email?: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Account/api/Account/ResetPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    confirmResetPassword(input: ResetPasswordInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/Account/api/Account/ConfirmResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmResetPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    putUser(input: InputUserDto): Observable<User> {
        let url_ = this.baseUrl + "/api/Account/PutUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUser(<any>response_);
                } catch (e) {
                    return <Observable<User>><any>_observableThrow(e);
                }
            } else
                return <Observable<User>><any>_observableThrow(response_);
        }));
    }

    protected processPutUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = User.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(<any>null);
    }

    getUser(userId?: string | null | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/Account/api/Account/GetUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(<any>response_);
                } catch (e) {
                    return <Observable<User>><any>_observableThrow(e);
                }
            } else
                return <Observable<User>><any>_observableThrow(response_);
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<User> {
        debugger;
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = User.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(<any>null);
    }

    changePassword(input: InputChangePasswordDto): Observable<ChangePasswordResult> {
        let url_ = this.baseUrl + "/api/Account/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<ChangePasswordResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangePasswordResult>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ChangePasswordResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangePasswordResult>(<any>null);
    }

    login(input: InputLoginDto): Observable<string> {
        let url_ = this.baseUrl + "/api/Account/api/Account/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class LocalizationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getEnglishResourceValue(key?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Localization/api/Localization/GetEnglishResourceValue?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEnglishResourceValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnglishResourceValue(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnglishResourceValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getArabicResourceValue(key?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Localization/api/Localization/GetArabicResourceValue?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArabicResourceValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArabicResourceValue(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetArabicResourceValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    getEnglishResources(): Observable<Resource[]> {
        let url_ = this.baseUrl + "/api/Localization/api/Localization/GetEnglishResources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEnglishResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnglishResources(<any>response_);
                } catch (e) {
                    return <Observable<Resource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Resource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnglishResources(response: HttpResponseBase): Observable<Resource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Resource.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Resource[]>(<any>null);
    }

    getArabicResources(): Observable<Resource[]> {
        let url_ = this.baseUrl + "/api/Localization/api/Localization/GetArabicResources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArabicResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArabicResources(<any>response_);
                } catch (e) {
                    return <Observable<Resource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Resource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetArabicResources(response: HttpResponseBase): Observable<Resource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Resource.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Resource[]>(<any>null);
    }
}

@Injectable()
export class ValuesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getAll(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Values";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    post(value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    get(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/Values/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    put(id: number, value: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Values/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Values/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BrandsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getBrands(): Observable<IndexEntity[]> {
        let url_ = this.baseUrl + "/api/Brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrands(<any>response_);
                } catch (e) {
                    return <Observable<IndexEntity[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<IndexEntity[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrands(response: HttpResponseBase): Observable<IndexEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(IndexEntity.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IndexEntity[]>(<any>null);
    }

    postBrand(input: BrandInputDto): Observable<Brand> {
        let url_ = this.baseUrl + "/api/Brands/PostBrand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBrand(<any>response_);
                } catch (e) {
                    return <Observable<Brand>><any>_observableThrow(e);
                }
            } else
                return <Observable<Brand>><any>_observableThrow(response_);
        }));
    }

    protected processPostBrand(response: HttpResponseBase): Observable<Brand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Brand.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Brand>(<any>null);
    }

    getBrand(id: number): Observable<Brand> {
        let url_ = this.baseUrl + "/api/Brands/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrand(<any>response_);
                } catch (e) {
                    return <Observable<Brand>><any>_observableThrow(e);
                }
            } else
                return <Observable<Brand>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrand(response: HttpResponseBase): Observable<Brand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Brand.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Brand>(<any>null);
    }

    putBrand(id: number, input: BrandInputDto): Observable<Brand> {
        let url_ = this.baseUrl + "/api/Brands/PutBrand";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        input.id = id;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutBrand(<any>response_);
                } catch (e) {
                    return <Observable<Brand>><any>_observableThrow(e);
                }
            } else
                return <Observable<Brand>><any>_observableThrow(response_);
        }));
    }

    protected processPutBrand(response: HttpResponseBase): Observable<Brand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Brand.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Brand>(<any>null);
    }

    deleteBrand(id: number, userId?: string | null | undefined): Observable<Brand> {
        let url_ = this.baseUrl + "/api/Brands/DeleteBrand";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        // if (userId !== undefined && userId !== null)
        //     url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        var input = new DeleteDto();
        input.id = id;
        input.userId = userId;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBrand(<any>response_);
                } catch (e) {
                    return <Observable<Brand>><any>_observableThrow(e);
                }
            } else
                return <Observable<Brand>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBrand(response: HttpResponseBase): Observable<Brand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Brand.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Brand>(<any>null);
    }
}

@Injectable()
export class LicenceTypesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getLicenceTypes(): Observable<IndexEntity[]> {
        debugger;
        let url_ = this.baseUrl + "/api/LicenceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLicenceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceTypes(<any>response_);
                } catch (e) {
                    return <Observable<IndexEntity[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<IndexEntity[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLicenceTypes(response: HttpResponseBase): Observable<IndexEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(IndexEntity.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IndexEntity[]>(<any>null);
    }

    postLicenceType(input: LicenceTypeInputDto): Observable<LicenceType> {
        let url_ = this.baseUrl + "/api/LicenceTypes/PostLicenceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostLicenceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLicenceType(<any>response_);
                } catch (e) {
                    return <Observable<LicenceType>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenceType>><any>_observableThrow(response_);
        }));
    }

    protected processPostLicenceType(response: HttpResponseBase): Observable<LicenceType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenceType.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceType>(<any>null);
    }

    getLicenceType(id: number): Observable<LicenceType> {
        let url_ = this.baseUrl + "/api/LicenceTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLicenceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceType(<any>response_);
                } catch (e) {
                    return <Observable<LicenceType>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenceType>><any>_observableThrow(response_);
        }));
    }

    protected processGetLicenceType(response: HttpResponseBase): Observable<LicenceType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenceType.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceType>(<any>null);
    }

    putLicenceType(id: number, input: LicenceTypeInputDto): Observable<LicenceType> {
        let url_ = this.baseUrl + "/api/LicenceTypes/PutLicenceType";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        input.id = id;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutLicenceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutLicenceType(<any>response_);
                } catch (e) {
                    return <Observable<LicenceType>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenceType>><any>_observableThrow(response_);
        }));
    }

    protected processPutLicenceType(response: HttpResponseBase): Observable<LicenceType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenceType.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceType>(<any>null);
    }

    deleteLicenceType(id: number, userId?: string | null | undefined): Observable<LicenceType> {
        let url_ = this.baseUrl + "/api/LicenceTypes/DeleteLicenceType";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        // url_ = url_.replace("{id}", encodeURIComponent("" + id));
        // if (userId !== undefined && userId !== null)
        //     url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        var input = new DeleteDto();
        input.id = id;
        input.userId = userId;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLicenceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLicenceType(<any>response_);
                } catch (e) {
                    return <Observable<LicenceType>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenceType>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLicenceType(response: HttpResponseBase): Observable<LicenceType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenceType.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenceType>(<any>null);
    }
}

@Injectable()
export class PlatformsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getPlatforms(): Observable<IndexEntity[]> {
        let url_ = this.baseUrl + "/api/Platforms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlatforms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatforms(<any>response_);
                } catch (e) {
                    return <Observable<IndexEntity[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<IndexEntity[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlatforms(response: HttpResponseBase): Observable<IndexEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(IndexEntity.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IndexEntity[]>(<any>null);
    }

    postPlatform(input: PlatformInputDto): Observable<Platform> {
        let url_ = this.baseUrl + "/api/Platforms/PostPlatform";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostPlatform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPlatform(<any>response_);
                } catch (e) {
                    return <Observable<Platform>><any>_observableThrow(e);
                }
            } else
                return <Observable<Platform>><any>_observableThrow(response_);
        }));
    }

    protected processPostPlatform(response: HttpResponseBase): Observable<Platform> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Platform.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Platform>(<any>null);
    }

    getPlatform(id: number): Observable<Platform> {
        let url_ = this.baseUrl + "/api/Platforms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlatform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlatform(<any>response_);
                } catch (e) {
                    return <Observable<Platform>><any>_observableThrow(e);
                }
            } else
                return <Observable<Platform>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlatform(response: HttpResponseBase): Observable<Platform> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Platform.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Platform>(<any>null);
    }

    putPlatform(id: number, input: PlatformInputDto): Observable<Platform> {
        let url_ = this.baseUrl + "/api/Platforms/PutPlatform";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        input.id = id;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutPlatform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPlatform(<any>response_);
                } catch (e) {
                    return <Observable<Platform>><any>_observableThrow(e);
                }
            } else
                return <Observable<Platform>><any>_observableThrow(response_);
        }));
    }

    protected processPutPlatform(response: HttpResponseBase): Observable<Platform> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Platform.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Platform>(<any>null);
    }

    deletePlatform(id: number, userId?: string | null | undefined): Observable<Platform> {
        let url_ = this.baseUrl + "/api/Platforms/DeletePlatform";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        // url_ = url_.replace("{id}", encodeURIComponent("" + id));
        // if (userId !== undefined && userId !== null)
        //     url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        // url_ = url_.replace(/[?&]$/, "");
        var input = new DeleteDto();
        input.id = id;
        input.userId = userId;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePlatform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePlatform(<any>response_);
                } catch (e) {
                    return <Observable<Platform>><any>_observableThrow(e);
                }
            } else
                return <Observable<Platform>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePlatform(response: HttpResponseBase): Observable<Platform> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Platform.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Platform>(<any>null);
    }
}

@Injectable()
export class ActivationKeysService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getActivationKeys(licenseKeyId?: number | undefined): Observable<ActivationKeyDto[]> {
        let url_ = this.baseUrl + "/api/ActivationKeys/api/ActivationKeys/GetAll?";
        if (licenseKeyId === null)
            throw new Error("The parameter 'licenseKeyId' cannot be null.");
        else if (licenseKeyId !== undefined)
            url_ += "licenseKeyId=" + encodeURIComponent("" + licenseKeyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActivationKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivationKeys(<any>response_);
                } catch (e) {
                    return <Observable<ActivationKeyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationKeyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivationKeys(response: HttpResponseBase): Observable<ActivationKeyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ActivationKeyDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationKeyDto[]>(<any>null);
    }
}

@Injectable()
export class CustomersService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getCustomers(filter: CustomerFilterDto): Observable<CustomerOutputDto> {
        let url_ = this.baseUrl + "/api/Customers/api/Customers/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(<any>response_);
                } catch (e) {
                    return <Observable<CustomerOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<CustomerOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerOutputDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerOutputDto>(<any>null);
    }

    getCustomer(id: number): Observable<Customer> {
        let url_ = this.baseUrl + "/api/Customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Customer.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }

    putCustomer(id: number, input: CustomerInputDto): Observable<Customer> {
        let url_ = this.baseUrl + "/api/Customers/PutCustomer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        input.id = id;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCustomer(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processPutCustomer(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Customer.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }

    deleteCustomer(id: number, userId?: string | null | undefined): Observable<Customer> {
        let url_ = this.baseUrl + "/api/Customers/DeleteCustomer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        // url_ = url_.replace("{id}", encodeURIComponent("" + id));
        // if (userId !== undefined && userId !== null)
        //     url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        // url_ = url_.replace(/[?&]$/, "");
        var input = new DeleteDto();
        input.id = id;
        input.userId = userId;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Customer.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }

    getCustomerByUserId(id?: string | null | undefined): Observable<CustomerInputDto> {
        let url_ = this.baseUrl + "/api/Customers/api/Customers/GetCustomerByUserId?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerByUserId(<any>response_);
                } catch (e) {
                    return <Observable<CustomerInputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerInputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerByUserId(response: HttpResponseBase): Observable<CustomerInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerInputDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerInputDto>(<any>null);
    }

    getCodesCustomer(id?: number | undefined): Observable<GenerateOutPutDto[]> {
        let url_ = this.baseUrl + "/api/Customers/api/Customers/GetCodesCustomer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCodesCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodesCustomer(<any>response_);
                } catch (e) {
                    return <Observable<GenerateOutPutDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GenerateOutPutDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCodesCustomer(response: HttpResponseBase): Observable<GenerateOutPutDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(GenerateOutPutDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenerateOutPutDto[]>(<any>null);
    }

    block(input: BlockInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Customers/api/Customers/Block";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlock(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processBlock(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    unBlock(input: BlockInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/Customers/api/Customers/UnBlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnBlock(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUnBlock(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    blockList(input: BlockListCustomerInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Customers/api/Customers/BlockList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBlockList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockList(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processBlockList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    postCustomer(input: CustomerInputDto): Observable<Customer> {
        debugger;
        let url_ = this.baseUrl + "/api/Customers/api/Customers/PostCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCustomer(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processPostCustomer(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Customer.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }
}

@Injectable()
export class LicenseKeyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getLicenseKeys(productTypeId?: number | undefined): Observable<LicenseKeyOutputDtoList> {
        let url_ = this.baseUrl + "/api/LicenseKey/api/LicenseKey/GetAll?";
        if (productTypeId === null)
            throw new Error("The parameter 'productTypeId' cannot be null.");
        else if (productTypeId !== undefined)
            url_ += "productTypeId=" + encodeURIComponent("" + productTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLicenseKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenseKeys(<any>response_);
                } catch (e) {
                    return <Observable<LicenseKeyOutputDtoList>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenseKeyOutputDtoList>><any>_observableThrow(response_);
        }));
    }

    protected processGetLicenseKeys(response: HttpResponseBase): Observable<LicenseKeyOutputDtoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenseKeyOutputDtoList.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenseKeyOutputDtoList>(<any>null);
    }

    getLicenseKey(id: number): Observable<LicenseKeyOutputDto> {
        let url_ = this.baseUrl + "/api/LicenseKey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLicenseKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenseKey(<any>response_);
                } catch (e) {
                    return <Observable<LicenseKeyOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenseKeyOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLicenseKey(response: HttpResponseBase): Observable<LicenseKeyOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenseKeyOutputDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenseKeyOutputDto>(<any>null);
    }

    putLicenseKey(id: number, input: LicenseKeyInputDto): Observable<LicenseKey> {
        let url_ = this.baseUrl + "/api/LicenseKey/PutLicenseKey";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        input.id = id;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutLicenseKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutLicenseKey(<any>response_);
                } catch (e) {
                    return <Observable<LicenseKey>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenseKey>><any>_observableThrow(response_);
        }));
    }

    protected processPutLicenseKey(response: HttpResponseBase): Observable<LicenseKey> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenseKey.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenseKey>(<any>null);
    }

    deleteLicenseKey(id: number, userId?: string | null | undefined): Observable<LicenseKey> {
        let url_ = this.baseUrl + "/api/LicenseKey/DeleteLicenseKey";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        // url_ = url_.replace("{id}", encodeURIComponent("" + id));
        // if (userId !== undefined && userId !== null)
        //     url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        // url_ = url_.replace(/[?&]$/, "");

        var input = new DeleteDto();
        input.id = id;
        input.userId = userId;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLicenseKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLicenseKey(<any>response_);
                } catch (e) {
                    return <Observable<LicenseKey>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenseKey>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLicenseKey(response: HttpResponseBase): Observable<LicenseKey> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenseKey.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenseKey>(<any>null);
    }

    postLicenseKey(input: LicenseKeyInputDto): Observable<LicenseKey> {
        let url_ = this.baseUrl + "/api/LicenseKey/PostLicenseKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostLicenseKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostLicenseKey(<any>response_);
                } catch (e) {
                    return <Observable<LicenseKey>><any>_observableThrow(e);
                }
            } else
                return <Observable<LicenseKey>><any>_observableThrow(response_);
        }));
    }

    protected processPostLicenseKey(response: HttpResponseBase): Observable<LicenseKey> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LicenseKey.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenseKey>(<any>null);
    }
}

@Injectable()
export class ProductTypesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getProductTypes(): Observable<ProductTypeOutputDto> {
        let url_ = this.baseUrl + "/api/ProductTypes/api/ProductTypes/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTypes(<any>response_);
                } catch (e) {
                    return <Observable<ProductTypeOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductTypeOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductTypes(response: HttpResponseBase): Observable<ProductTypeOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductTypeOutputDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductTypeOutputDto>(<any>null);
    }

    getProductType(id: number, code?: string | null | undefined): Observable<ProductOutputDto> {
        let url_ = this.baseUrl + "/api/ProductTypes/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductType(<any>response_);
                } catch (e) {
                    return <Observable<ProductOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductType(response: HttpResponseBase): Observable<ProductOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductOutputDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductOutputDto>(<any>null);
    }

    putProductType(id: number, input: ProductTypeInputDto): Observable<ProductType> {
        let url_ = this.baseUrl + "/api/ProductTypes/PutProductType";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        input.id = id;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutProductType(<any>response_);
                } catch (e) {
                    return <Observable<ProductType>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductType>><any>_observableThrow(response_);
        }));
    }

    protected processPutProductType(response: HttpResponseBase): Observable<ProductType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductType.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductType>(<any>null);
    }

    deleteProductType(id: number, userId?: string | null | undefined): Observable<ProductType> {
        let url_ = this.baseUrl + "/api/ProductTypes/DeleteProductType";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        // url_ = url_.replace("{id}", encodeURIComponent("" + id));
        // if (userId !== undefined && userId !== null)
        //     url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        // url_ = url_.replace(/[?&]$/, "");
        var input = new DeleteDto();
        input.id = id;
        input.userId = userId;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductType(<any>response_);
                } catch (e) {
                    return <Observable<ProductType>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductType>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteProductType(response: HttpResponseBase): Observable<ProductType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductType.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductType>(<any>null);
    }

    postProductType(input: ProductTypeInputDto): Observable<ProductType> {
        let url_ = this.baseUrl + "/api/ProductTypes/PostProductType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostProductType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostProductType(<any>response_);
                } catch (e) {
                    return <Observable<ProductType>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductType>><any>_observableThrow(response_);
        }));
    }

    protected processPostProductType(response: HttpResponseBase): Observable<ProductType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductType.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductType>(<any>null);
    }
}

@Injectable()
export class QuestionsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getQuestions(): Observable<QuestionOutputDto[]> {
        let url_ = this.baseUrl + "/api/Questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestions(<any>response_);
                } catch (e) {
                    return <Observable<QuestionOutputDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuestionOutputDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuestions(response: HttpResponseBase): Observable<QuestionOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(QuestionOutputDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionOutputDto[]>(<any>null);
    }

    postBrand(input: QuestionInputDto): Observable<Question> {
        let url_ = this.baseUrl + "/api/Questions/PostQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostBrand(<any>response_);
                } catch (e) {
                    return <Observable<Question>><any>_observableThrow(e);
                }
            } else
                return <Observable<Question>><any>_observableThrow(response_);
        }));
    }

    protected processPostBrand(response: HttpResponseBase): Observable<Question> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Question.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Question>(<any>null);
    }

    getQuestion(id: number): Observable<Question> {
        let url_ = this.baseUrl + "/api/Questions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestion(<any>response_);
                } catch (e) {
                    return <Observable<Question>><any>_observableThrow(e);
                }
            } else
                return <Observable<Question>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuestion(response: HttpResponseBase): Observable<Question> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Question.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Question>(<any>null);
    }

    putBrand(id: number, input: QuestionInputDto): Observable<Question> {
        let url_ = this.baseUrl + "/api/Questions/PutQuestion";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        //url_ = url_.replace("{id}", encodeURIComponent("" + id));
        input.id = id;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPutBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutBrand(<any>response_);
                } catch (e) {
                    return <Observable<Question>><any>_observableThrow(e);
                }
            } else
                return <Observable<Question>><any>_observableThrow(response_);
        }));
    }

    protected processPutBrand(response: HttpResponseBase): Observable<Question> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Question.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Question>(<any>null);
    }

    deleteBrand(id: number, userId?: string | null | undefined): Observable<Question> {
        let url_ = this.baseUrl + "/api/Questions/DeleteQuestion";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        // url_ = url_.replace("{id}", encodeURIComponent("" + id));
        // if (userId !== undefined && userId !== null)
        //     url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        // url_ = url_.replace(/[?&]$/, "");
        var input = new DeleteDto();
        input.id = id;
        input.userId = userId;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBrand(<any>response_);
                } catch (e) {
                    return <Observable<Question>><any>_observableThrow(e);
                }
            } else
                return <Observable<Question>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBrand(response: HttpResponseBase): Observable<Question> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Question.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Question>(<any>null);
    }
}

@Injectable()
export class RedeemCodesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "https://generatorsy.xyz";
    }

    getRedeemCodes(filter: RedeemCodeFilterDto): Observable<RedeemCodeOutputDto> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/GetRedeemCodes";
        url_ = url_.replace(/[?&]$/, "");

        debugger;
        const content_ = JSON.stringify(filter);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRedeemCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedeemCodes(<any>response_);
                } catch (e) {
                    return <Observable<RedeemCodeOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RedeemCodeOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedeemCodes(response: HttpResponseBase): Observable<RedeemCodeOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RedeemCodeOutputDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RedeemCodeOutputDto>(<any>null);
    }

    getCustomersRedeemCodes(): Observable<CustomerCodeOutputDto[]> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/GetCustomersRedeemCodes?";
        
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomersRedeemCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersRedeemCodes(<any>response_);
                } catch (e) {
                    return <Observable<CustomerCodeOutputDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerCodeOutputDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomersRedeemCodes(response: HttpResponseBase): Observable<CustomerCodeOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CustomerCodeOutputDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerCodeOutputDto[]>(<any>null);
    }

    getRedeemCode(id: number): Observable<RedeemCode> {
        let url_ = this.baseUrl + "/api/RedeemCodes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRedeemCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedeemCode(<any>response_);
                } catch (e) {
                    return <Observable<RedeemCode>><any>_observableThrow(e);
                }
            } else
                return <Observable<RedeemCode>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedeemCode(response: HttpResponseBase): Observable<RedeemCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RedeemCode.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RedeemCode>(<any>null);
    }

    blockCode(input: BlockInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/BlockCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBlockCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockCode(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processBlockCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
    blockList(input: BlockListInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/BlockList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnBlockCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnBlockCode(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }
    unBlockList(input: BlockListInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/UnBlockList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnBlockCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnBlockCode(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }
    unBlockCode(input: BlockInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/UnBlockCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnBlockCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnBlockCode(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUnBlockCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    activeCode(input: BlockInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/ActiveCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActiveCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processActiveCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    sendTemporaryCode(input: TemporaryInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/SendTemporaryCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendTemporaryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTemporaryCode(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processSendTemporaryCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
    checkCode(input: CheckInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/CheckCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCode(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCode(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
    checkCodeFromQR(input: CheckInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/CheckCodeFromQR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCode(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCodeFromQR(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
    generateCode(input: CodeInputDto): Observable<GenerateOutPutDto[]> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCode(<any>response_);
                } catch (e) {
                    return <Observable<GenerateOutPutDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GenerateOutPutDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateCode(response: HttpResponseBase): Observable<GenerateOutPutDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(GenerateOutPutDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenerateOutPutDto[]>(<any>null);
    }

    getRedeemCodesByTypeId(typeId?: number | undefined): Observable<CodeOutputDto[]> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/GetRedeemCodesByTypeId?";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRedeemCodesByTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedeemCodesByTypeId(<any>response_);
                } catch (e) {
                    return <Observable<CodeOutputDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CodeOutputDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedeemCodesByTypeId(response: HttpResponseBase): Observable<CodeOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CodeOutputDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CodeOutputDto[]>(<any>null);
    }

    deleteRedeemCode(input: BlockInputDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/DeleteRedeemCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteRedeemCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRedeemCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRedeemCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    exportToCsv(count?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/ExportToCsv?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToCsv(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportToCsv(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    exportToExcel(count?: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/RedeemCodes/api/RedeemCodes/ExportToExcel?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportToExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

export class OutputUserDto implements IOutputUserDto {
    users?: UserCustomer[] | null;
    count?: number | null;

    constructor(data?: IOutputUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserCustomer.fromJS(item));
            }
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): OutputUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutputUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }
}

export interface IOutputUserDto {
    users?: UserCustomer[] | null;
    count?: number | null;
}

export class UserCustomer implements IUserCustomer {
    user?: User | null;
    customer?: Customer | null;

    constructor(data?: IUserCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>null;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>null;
        }
    }

    static fromJS(data: any): UserCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        return data;
    }
}

export interface IUserCustomer {
    user?: User | null;
    customer?: Customer | null;
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id?: string | null;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed!: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed!: boolean;
    twoFactorEnabled!: boolean;
    lockoutEnd?: Date | null;
    lockoutEnabled!: boolean;
    accessFailedCount!: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.normalizedUserName = _data["normalizedUserName"] !== undefined ? _data["normalizedUserName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.normalizedEmail = _data["normalizedEmail"] !== undefined ? _data["normalizedEmail"] : <any>null;
            this.emailConfirmed = _data["emailConfirmed"] !== undefined ? _data["emailConfirmed"] : <any>null;
            this.passwordHash = _data["passwordHash"] !== undefined ? _data["passwordHash"] : <any>null;
            this.securityStamp = _data["securityStamp"] !== undefined ? _data["securityStamp"] : <any>null;
            this.concurrencyStamp = _data["concurrencyStamp"] !== undefined ? _data["concurrencyStamp"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"] !== undefined ? _data["phoneNumberConfirmed"] : <any>null;
            this.twoFactorEnabled = _data["twoFactorEnabled"] !== undefined ? _data["twoFactorEnabled"] : <any>null;
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>null;
            this.lockoutEnabled = _data["lockoutEnabled"] !== undefined ? _data["lockoutEnabled"] : <any>null;
            this.accessFailedCount = _data["accessFailedCount"] !== undefined ? _data["accessFailedCount"] : <any>null;
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["normalizedUserName"] = this.normalizedUserName !== undefined ? this.normalizedUserName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["normalizedEmail"] = this.normalizedEmail !== undefined ? this.normalizedEmail : <any>null;
        data["emailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : <any>null;
        data["passwordHash"] = this.passwordHash !== undefined ? this.passwordHash : <any>null;
        data["securityStamp"] = this.securityStamp !== undefined ? this.securityStamp : <any>null;
        data["concurrencyStamp"] = this.concurrencyStamp !== undefined ? this.concurrencyStamp : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed !== undefined ? this.phoneNumberConfirmed : <any>null;
        data["twoFactorEnabled"] = this.twoFactorEnabled !== undefined ? this.twoFactorEnabled : <any>null;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>null;
        data["lockoutEnabled"] = this.lockoutEnabled !== undefined ? this.lockoutEnabled : <any>null;
        data["accessFailedCount"] = this.accessFailedCount !== undefined ? this.accessFailedCount : <any>null;
        return data;
    }
}

export interface IIdentityUserOfString {
    id?: string | null;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd?: Date | null;
    lockoutEnabled: boolean;
    accessFailedCount: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export class User extends IdentityUser implements IUser {
    isAdmin!: boolean;
    hasWrittingAccess!: boolean;
    isCustomer!: boolean;

    constructor(data?: IUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : <any>null;
            this.hasWrittingAccess = _data["hasWrittingAccess"] !== undefined ? _data["hasWrittingAccess"] : <any>null;
            this.isCustomer = _data["isCustomer"] !== undefined ? _data["isCustomer"] : <any>null;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        data["hasWrittingAccess"] = this.hasWrittingAccess !== undefined ? this.hasWrittingAccess : <any>null;
        data["isCustomer"] = this.isCustomer !== undefined ? this.isCustomer : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IIdentityUser {
    isAdmin: boolean;
    hasWrittingAccess: boolean;
    isCustomer: boolean;
}

export class AuditEntity implements IAuditEntity {
    id!: number;
    virtualDeleted!: boolean;
    createdUserId?: string | null;
    createdUser?: User | null;
    createdDate?: Date | null;
    updatedUserId?: string | null;
    updatedUser?: User | null;
    updatedDate?: Date | null;
    deletedUserId?: string | null;
    deletedUser?: User | null;
    deletedDate?: Date | null;

    constructor(data?: IAuditEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.virtualDeleted = _data["virtualDeleted"] !== undefined ? _data["virtualDeleted"] : <any>null;
            this.createdUserId = _data["createdUserId"] !== undefined ? _data["createdUserId"] : <any>null;
            this.createdUser = _data["createdUser"] ? User.fromJS(_data["createdUser"]) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedUserId = _data["updatedUserId"] !== undefined ? _data["updatedUserId"] : <any>null;
            this.updatedUser = _data["updatedUser"] ? User.fromJS(_data["updatedUser"]) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.deletedUserId = _data["deletedUserId"] !== undefined ? _data["deletedUserId"] : <any>null;
            this.deletedUser = _data["deletedUser"] ? User.fromJS(_data["deletedUser"]) : <any>null;
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AuditEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["virtualDeleted"] = this.virtualDeleted !== undefined ? this.virtualDeleted : <any>null;
        data["createdUserId"] = this.createdUserId !== undefined ? this.createdUserId : <any>null;
        data["createdUser"] = this.createdUser ? this.createdUser.toJSON() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedUserId"] = this.updatedUserId !== undefined ? this.updatedUserId : <any>null;
        data["updatedUser"] = this.updatedUser ? this.updatedUser.toJSON() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["deletedUserId"] = this.deletedUserId !== undefined ? this.deletedUserId : <any>null;
        data["deletedUser"] = this.deletedUser ? this.deletedUser.toJSON() : <any>null;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IAuditEntity {
    id: number;
    virtualDeleted: boolean;
    createdUserId?: string | null;
    createdUser?: User | null;
    createdDate?: Date | null;
    updatedUserId?: string | null;
    updatedUser?: User | null;
    updatedDate?: Date | null;
    deletedUserId?: string | null;
    deletedUser?: User | null;
    deletedDate?: Date | null;
}

export class Customer extends AuditEntity implements ICustomer {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    country?: string | null;
    city?: string | null;
    phone?: string | null;
    ipAddress?: string | null;
    email?: string | null;
    numberOfActivations!: number;
    blocked!: boolean;
    userId?: string | null;
    user?: User | null;
    codes?: RedeemCode[] | null;

    constructor(data?: ICustomer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.ipAddress = _data["ipAddress"] !== undefined ? _data["ipAddress"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.numberOfActivations = _data["numberOfActivations"] !== undefined ? _data["numberOfActivations"] : <any>null;
            this.blocked = _data["blocked"] !== undefined ? _data["blocked"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>null;
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(RedeemCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["numberOfActivations"] = this.numberOfActivations !== undefined ? this.numberOfActivations : <any>null;
        data["blocked"] = this.blocked !== undefined ? this.blocked : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomer extends IAuditEntity {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    country?: string | null;
    city?: string | null;
    phone?: string | null;
    ipAddress?: string | null;
    email?: string | null;
    numberOfActivations: number;
    blocked: boolean;
    userId?: string | null;
    user?: User | null;
    codes?: RedeemCode[] | null;
}

export class RedeemCode extends AuditEntity implements IRedeemCode {
    code?: string | null;
    status!: Status;
    activationDate?: Date | null;
    customerId?: number | null;
    customer?: Customer | null;
    typeId?: number | null;
    productType?: ProductType | null;

    constructor(data?: IRedeemCode) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>null;
            this.typeId = _data["typeId"] !== undefined ? _data["typeId"] : <any>null;
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : <any>null;
        }
    }

    static fromJS(data: any): RedeemCode {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        data["typeId"] = this.typeId !== undefined ? this.typeId : <any>null;
        data["productType"] = this.productType ? this.productType.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRedeemCode extends IAuditEntity {
    code?: string | null;
    status: Status;
    activationDate?: Date | null;
    customerId?: number | null;
    customer?: Customer | null;
    typeId?: number | null;
    productType?: ProductType | null;
}

export enum Status {
    Activated = 0,
    NotActivated = 1,
    Blocked = 2,
    WaitingActivation = 3,
}

export class ProductType extends AuditEntity implements IProductType {
    name?: string | null;
    arabicName?: string | null;
    licenceTypeId?: number | null;
    licenceType?: LicenceType | null;
    brandId?: number | null;
    brand?: Brand | null;
    howToActivate?: string | null;
    arabicHowToActivate?: string | null;
    platformId?: number | null;
    platform?: Platform | null;
    description?: string | null;
    arabicDescription?: string | null;
    activatedCount!: number;
    generatedCount!: number;
    autoSentLicenseKey!: boolean;
    codes?: RedeemCode[] | null;
    licenseKeys?: LicenseKey[] | null;

    constructor(data?: IProductType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.arabicName = _data["arabicName"] !== undefined ? _data["arabicName"] : <any>null;
            this.licenceTypeId = _data["licenceTypeId"] !== undefined ? _data["licenceTypeId"] : <any>null;
            this.licenceType = _data["licenceType"] ? LicenceType.fromJS(_data["licenceType"]) : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : <any>null;
            this.howToActivate = _data["howToActivate"] !== undefined ? _data["howToActivate"] : <any>null;
            this.arabicHowToActivate = _data["arabicHowToActivate"] !== undefined ? _data["arabicHowToActivate"] : <any>null;
            this.platformId = _data["platformId"] !== undefined ? _data["platformId"] : <any>null;
            this.platform = _data["platform"] ? Platform.fromJS(_data["platform"]) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.arabicDescription = _data["arabicDescription"] !== undefined ? _data["arabicDescription"] : <any>null;
            this.activatedCount = _data["activatedCount"] !== undefined ? _data["activatedCount"] : <any>null;
            this.generatedCount = _data["generatedCount"] !== undefined ? _data["generatedCount"] : <any>null;
            this.autoSentLicenseKey = _data["autoSentLicenseKey"] !== undefined ? _data["autoSentLicenseKey"] : <any>null;
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(RedeemCode.fromJS(item));
            }
            if (Array.isArray(_data["licenseKeys"])) {
                this.licenseKeys = [] as any;
                for (let item of _data["licenseKeys"])
                    this.licenseKeys!.push(LicenseKey.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["arabicName"] = this.arabicName !== undefined ? this.arabicName : <any>null;
        data["licenceTypeId"] = this.licenceTypeId !== undefined ? this.licenceTypeId : <any>null;
        data["licenceType"] = this.licenceType ? this.licenceType.toJSON() : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["brand"] = this.brand ? this.brand.toJSON() : <any>null;
        data["howToActivate"] = this.howToActivate !== undefined ? this.howToActivate : <any>null;
        data["arabicHowToActivate"] = this.arabicHowToActivate !== undefined ? this.arabicHowToActivate : <any>null;
        data["platformId"] = this.platformId !== undefined ? this.platformId : <any>null;
        data["platform"] = this.platform ? this.platform.toJSON() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["arabicDescription"] = this.arabicDescription !== undefined ? this.arabicDescription : <any>null;
        data["activatedCount"] = this.activatedCount !== undefined ? this.activatedCount : <any>null;
        data["generatedCount"] = this.generatedCount !== undefined ? this.generatedCount : <any>null;
        data["autoSentLicenseKey"] = this.autoSentLicenseKey !== undefined ? this.autoSentLicenseKey : <any>null;
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item.toJSON());
        }
        if (Array.isArray(this.licenseKeys)) {
            data["licenseKeys"] = [];
            for (let item of this.licenseKeys)
                data["licenseKeys"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProductType extends IAuditEntity {
    name?: string | null;
    arabicName?: string | null;
    licenceTypeId?: number | null;
    licenceType?: LicenceType | null;
    brandId?: number | null;
    brand?: Brand | null;
    howToActivate?: string | null;
    arabicHowToActivate?: string | null;
    platformId?: number | null;
    platform?: Platform | null;
    description?: string | null;
    arabicDescription?: string | null;
    activatedCount: number;
    generatedCount: number;
    autoSentLicenseKey: boolean;
    codes?: RedeemCode[] | null;
    licenseKeys?: LicenseKey[] | null;
}

export class IndexEntity extends AuditEntity implements IIndexEntity {
    name?: string | null;
    arabicName?: string | null;

    constructor(data?: IIndexEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.arabicName = _data["arabicName"] !== undefined ? _data["arabicName"] : <any>null;
        }
    }

    static fromJS(data: any): IndexEntity {
        data = typeof data === 'object' ? data : {};
        let result = new IndexEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["arabicName"] = this.arabicName !== undefined ? this.arabicName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIndexEntity extends IAuditEntity {
    name?: string | null;
    arabicName?: string | null;
}

export class LicenceType extends IndexEntity implements ILicenceType {

    constructor(data?: ILicenceType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LicenceType {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILicenceType extends IIndexEntity {
}
export interface IDeleteDto{
    id?: number | null;
    userId?: string | null;
}
export class DeleteDto implements IDeleteDto{
    id?: number | null;
    userId?: string | null;
    
    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}
export class Brand extends IndexEntity implements IBrand {

    constructor(data?: IBrand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): Brand {
        data = typeof data === 'object' ? data : {};
        let result = new Brand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBrand extends IIndexEntity {
}

export class Platform extends IndexEntity implements IPlatform {

    constructor(data?: IPlatform) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): Platform {
        data = typeof data === 'object' ? data : {};
        let result = new Platform();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPlatform extends IIndexEntity {
}

export class LicenseKey extends AuditEntity implements ILicenseKey {
    key?: string | null;
    order!: number;
    downloadUrl?: string | null;
    expires?: string | null;
    count!: number;
    remainingCount!: number;
    typeId?: number | null;
    productType?: ProductType | null;
    activationKeys?: ActivationKey[] | null;

    constructor(data?: ILicenseKey) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : <any>null;
            this.expires = _data["expires"] !== undefined ? _data["expires"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.remainingCount = _data["remainingCount"] !== undefined ? _data["remainingCount"] : <any>null;
            this.typeId = _data["typeId"] !== undefined ? _data["typeId"] : <any>null;
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : <any>null;
            if (Array.isArray(_data["activationKeys"])) {
                this.activationKeys = [] as any;
                for (let item of _data["activationKeys"])
                    this.activationKeys!.push(ActivationKey.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LicenseKey {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : <any>null;
        data["expires"] = this.expires !== undefined ? this.expires : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["remainingCount"] = this.remainingCount !== undefined ? this.remainingCount : <any>null;
        data["typeId"] = this.typeId !== undefined ? this.typeId : <any>null;
        data["productType"] = this.productType ? this.productType.toJSON() : <any>null;
        if (Array.isArray(this.activationKeys)) {
            data["activationKeys"] = [];
            for (let item of this.activationKeys)
                data["activationKeys"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILicenseKey extends IAuditEntity {
    key?: string | null;
    order: number;
    downloadUrl?: string | null;
    expires?: string | null;
    count: number;
    remainingCount: number;
    typeId?: number | null;
    productType?: ProductType | null;
    activationKeys?: ActivationKey[] | null;
}

export class ActivationKey extends AuditEntity implements IActivationKey {
    status!: Status;
    activationDate?: Date | null;
    customerId?: number | null;
    customer?: Customer | null;
    licenseKeyId?: number | null;
    licenseKey?: LicenseKey | null;

    constructor(data?: IActivationKey) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>null;
            this.licenseKeyId = _data["licenseKeyId"] !== undefined ? _data["licenseKeyId"] : <any>null;
            this.licenseKey = _data["licenseKey"] ? LicenseKey.fromJS(_data["licenseKey"]) : <any>null;
        }
    }

    static fromJS(data: any): ActivationKey {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        data["licenseKeyId"] = this.licenseKeyId !== undefined ? this.licenseKeyId : <any>null;
        data["licenseKey"] = this.licenseKey ? this.licenseKey.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IActivationKey extends IAuditEntity {
    status: Status;
    activationDate?: Date | null;
    customerId?: number | null;
    customer?: Customer | null;
    licenseKeyId?: number | null;
    licenseKey?: LicenseKey | null;
}

export class InputUserDto implements IInputUserDto {
    id?: string | null;
    password?: string | null;
    userName?: string | null;
    email?: string | null;
    isAdmin!: boolean;
    hasWrittingAccess!: boolean;
    isCustomer!: boolean;
    phone?: string | null;

    constructor(data?: IInputUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.isAdmin = _data["isAdmin"] !== undefined ? _data["isAdmin"] : <any>null;
            this.hasWrittingAccess = _data["hasWrittingAccess"] !== undefined ? _data["hasWrittingAccess"] : <any>null;
            this.isCustomer = _data["isCustomer"] !== undefined ? _data["isCustomer"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
        }
    }

    static fromJS(data: any): InputUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["isAdmin"] = this.isAdmin !== undefined ? this.isAdmin : <any>null;
        data["hasWrittingAccess"] = this.hasWrittingAccess !== undefined ? this.hasWrittingAccess : <any>null;
        data["isCustomer"] = this.isCustomer !== undefined ? this.isCustomer : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        return data;
    }
}

export interface IInputUserDto {
    id?: string | null;
    password?: string | null;
    userName?: string | null;
    email?: string | null;
    isAdmin: boolean;
    hasWrittingAccess: boolean;
    isCustomer: boolean;
    phone?: string | null;
}

export class ResetPasswordInputDto implements IResetPasswordInputDto {
    email?: string | null;
    code?: string | null;

    constructor(data?: IResetPasswordInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data;
    }
}

export interface IResetPasswordInputDto {
    email?: string | null;
    code?: string | null;
}

export enum ChangePasswordResult {
    UserNotFound = 0,
    NewPasswordDoesntMatchConfirm = 1,
    OldPasswordNotCorrect = 2,
    Successed = 3,
    Exception = 4,
    Failer = 5,
}

export class InputChangePasswordDto implements IInputChangePasswordDto {
    userId?: string | null;
    password?: string | null;
    newPassword?: string | null;
    confirmPassword?: string | null;

    constructor(data?: IInputChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
        }
    }

    static fromJS(data: any): InputChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        return data;
    }
}

export interface IInputChangePasswordDto {
    userId?: string | null;
    password?: string | null;
    newPassword?: string | null;
    confirmPassword?: string | null;
}

export class InputLoginDto implements IInputLoginDto {
    email?: string | null;
    password?: string | null;

    constructor(data?: IInputLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): InputLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

export interface IInputLoginDto {
    email?: string | null;
    password?: string | null;
}

export class Resource implements IResource {
    key?: string | null;
    value?: string | null;

    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IResource {
    key?: string | null;
    value?: string | null;
}

export class IndexDto implements IIndexDto {
    id?:number | null;
    name?: string | null;
    arabicName?: string | null;
    userId?: string | null;

    constructor(data?: IIndexDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.arabicName = _data["arabicName"] !== undefined ? _data["arabicName"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): IndexDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndexDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["arabicName"] = this.arabicName !== undefined ? this.arabicName : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IIndexDto {
    id?:number | null;
    name?: string | null;
    arabicName?: string | null;
    userId?: string | null;
}

export class BrandInputDto extends IndexDto implements IBrandInputDto {

    constructor(data?: IBrandInputDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BrandInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrandInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBrandInputDto extends IIndexDto {
}

export class LicenceTypeInputDto extends IndexDto implements ILicenceTypeInputDto {

    constructor(data?: ILicenceTypeInputDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LicenceTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILicenceTypeInputDto extends IIndexDto {
}

export class PlatformInputDto extends IndexDto implements IPlatformInputDto {

    constructor(data?: IPlatformInputDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PlatformInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatformInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPlatformInputDto extends IIndexDto {
}

export class ActivationKeyDto implements IActivationKeyDto {
    id!: number;
    status!: Status;
    activationDate?: string | null;
    customerId!: number;
    customerName?: string | null;
    licenseKeyId!: number;
    licenseKey?: string | null;

    constructor(data?: IActivationKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.activationDate = _data["activationDate"] !== undefined ? _data["activationDate"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : <any>null;
            this.licenseKeyId = _data["licenseKeyId"] !== undefined ? _data["licenseKeyId"] : <any>null;
            this.licenseKey = _data["licenseKey"] !== undefined ? _data["licenseKey"] : <any>null;
        }
    }

    static fromJS(data: any): ActivationKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["activationDate"] = this.activationDate !== undefined ? this.activationDate : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : <any>null;
        data["licenseKeyId"] = this.licenseKeyId !== undefined ? this.licenseKeyId : <any>null;
        data["licenseKey"] = this.licenseKey !== undefined ? this.licenseKey : <any>null;
        return data;
    }
}

export interface IActivationKeyDto {
    id: number;
    status: Status;
    activationDate?: string | null;
    customerId: number;
    customerName?: string | null;
    licenseKeyId: number;
    licenseKey?: string | null;
}

export class CustomerOutputDto implements ICustomerOutputDto {
    customers?: Customer[] | null;
    allCount!: number;

    constructor(data?: ICustomerOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(Customer.fromJS(item));
            }
            this.allCount = _data["allCount"] !== undefined ? _data["allCount"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["allCount"] = this.allCount !== undefined ? this.allCount : <any>null;
        return data;
    }
}

export interface ICustomerOutputDto {
    customers?: Customer[] | null;
    allCount: number;
}

export class CustomerFilterDto implements ICustomerFilterDto {
    country?: string | null;
    count?: number | null;
    skip?: number | null;

    constructor(data?: ICustomerFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.skip = _data["skip"] !== undefined ? _data["skip"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        return data;
    }
}

export interface ICustomerFilterDto {
    country?: string | null;
    count?: number | null;
    skip?: number | null;
}

export class CustomerInputDto implements ICustomerInputDto {
    id!: number;
    firstName?: string | null;
    lastName?: string | null;
    country?: string | null;
    city?: string | null;
    phone?: string | null;
    email?: string | null;
    password?: string | null;
    ipAddress?: string | null;
    userId?: string | null;
    updatedUserId?: string | null;

    constructor(data?: ICustomerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.ipAddress = _data["ipAddress"] !== undefined ? _data["ipAddress"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.updatedUserId = _data["updatedUserId"] !== undefined ? _data["updatedUserId"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["updatedUserId"] = this.updatedUserId !== undefined ? this.updatedUserId : <any>null;
        return data;
    }
}

export interface ICustomerInputDto {
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    country?: string | null;
    city?: string | null;
    phone?: string | null;
    email?: string | null;
    password?: string | null;
    ipAddress?: string | null;
    userId?: string | null;
    updatedUserId?: string | null;
}

export class GenerateOutPutDto implements IGenerateOutPutDto {
    id!: number;
    code?: string | null;
    productType?: string | null;
    licenceType?: string | null;
    activationDate?: string | null;
    createdDate?: string | null;
    strStatus?: string | null;
    createdDateTime!: Date;
    qrCode?:string | null;

    constructor(data?: IGenerateOutPutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
            this.licenceType = _data["licenceType"] !== undefined ? _data["licenceType"] : <any>null;
            this.activationDate = _data["activationDate"] !== undefined ? _data["activationDate"] : <any>null;
            this.createdDate = _data["createdDate"] !== undefined ? _data["createdDate"] : <any>null;
            this.strStatus = _data["strStatus"] !== undefined ? _data["strStatus"] : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>null;
            this.qrCode = _data["qrCode"] !== undefined ? _data["qrCode"] : <any>null;
        }
    }

    static fromJS(data: any): GenerateOutPutDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateOutPutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        data["licenceType"] = this.licenceType !== undefined ? this.licenceType : <any>null;
        data["activationDate"] = this.activationDate !== undefined ? this.activationDate : <any>null;
        data["createdDate"] = this.createdDate !== undefined ? this.createdDate : <any>null;
        data["strStatus"] = this.strStatus !== undefined ? this.strStatus : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["qrCode"] = this.qrCode !== undefined ? this.qrCode : <any>null;
        return data;
    }
}

export interface IGenerateOutPutDto {
    id: number;
    code?: string | null;
    productType?: string | null;
    licenceType?: string | null;
    activationDate?: string | null;
    createdDate?: string | null;
    strStatus?: string | null;
    createdDateTime: Date;
    qrCode?: string | null;
}

export class BlockInputDto implements IBlockInputDto {
    id!: number;
    userId?: string | null;

    constructor(data?: IBlockInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): BlockInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IBlockInputDto {
    id: number;
    userId?: string | null;
}

export class BlockListInputDto implements IBlockListInputDto {
    codes?: string[] | null;
    userId?: string | null;

    constructor(data?: IBlockListInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(item);
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): BlockListInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockListInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item);
        }
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IBlockListInputDto {
    codes?: string[] | null;
    userId?: string | null;
}
export class BlockListCustomerInputDto implements IBlockListCustomerInputDto {
    ids?: number[] | null;
    userId?: string | null;

    constructor(data?: IBlockListCustomerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): BlockListCustomerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockListCustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IBlockListCustomerInputDto {
    ids?: number[] | null;
    userId?: string | null;
}
export class LicenseKeyOutputDtoList implements ILicenseKeyOutputDtoList {
    data?: LicenseKeyOutputDto[] | null;
    count!: number;

    constructor(data?: ILicenseKeyOutputDtoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LicenseKeyOutputDto.fromJS(item));
            }
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): LicenseKeyOutputDtoList {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseKeyOutputDtoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }
}

export interface ILicenseKeyOutputDtoList {
    data?: LicenseKeyOutputDto[] | null;
    count: number;
}

export class LicenseKeyOutputDto implements ILicenseKeyOutputDto {
    id!: number;
    key?: string | null;
    downloadUrl?: string | null;
    expires?: string | null;
    count!: number;
    order!: number;
    remainingCount!: number;
    typeId?: number | null;
    productType?: string | null;

    constructor(data?: ILicenseKeyOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : <any>null;
            this.expires = _data["expires"] !== undefined ? _data["expires"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.remainingCount = _data["remainingCount"] !== undefined ? _data["remainingCount"] : <any>null;
            this.typeId = _data["typeId"] !== undefined ? _data["typeId"] : <any>null;
            this.productType = _data["productType"] !== undefined ? _data["productType"] : <any>null;
        }
    }

    static fromJS(data: any): LicenseKeyOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseKeyOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : <any>null;
        data["expires"] = this.expires !== undefined ? this.expires : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["remainingCount"] = this.remainingCount !== undefined ? this.remainingCount : <any>null;
        data["typeId"] = this.typeId !== undefined ? this.typeId : <any>null;
        data["productType"] = this.productType !== undefined ? this.productType : <any>null;
        return data;
    }
}

export interface ILicenseKeyOutputDto {
    id: number;
    key?: string | null;
    downloadUrl?: string | null;
    expires?: string | null;
    count: number;
    order: number;
    remainingCount: number;
    typeId?: number | null;
    productType?: string | null;
}

export class LicenseKeyInputDto implements ILicenseKeyInputDto {
    id?:number | null;
    key?: string | null;
    downloadUrl?: string | null;
    expires?: string | null;
    count!: number;
    order!: number;
    remainingCount!: number;
    typeId?: number | null;
    userId?: string | null;

    constructor(data?: ILicenseKeyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : <any>null;
            this.expires = _data["expires"] !== undefined ? _data["expires"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.remainingCount = _data["remainingCount"] !== undefined ? _data["remainingCount"] : <any>null;
            this.typeId = _data["typeId"] !== undefined ? _data["typeId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): LicenseKeyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseKeyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : <any>null;
        data["expires"] = this.expires !== undefined ? this.expires : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["remainingCount"] = this.remainingCount !== undefined ? this.remainingCount : <any>null;
        data["typeId"] = this.typeId !== undefined ? this.typeId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface ILicenseKeyInputDto {
    id?:number | null;
    key?: string | null;
    downloadUrl?: string | null;
    expires?: string | null;
    count: number;
    order: number;
    remainingCount: number;
    typeId?: number | null;
    userId?: string | null;
}

export class ProductTypeOutputDto implements IProductTypeOutputDto {
    productTypes?: ProductOutputDto[] | null;
    allCount!: number;

    constructor(data?: IProductTypeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["productTypes"])
                    this.productTypes!.push(ProductOutputDto.fromJS(item));
            }
            this.allCount = _data["allCount"] !== undefined ? _data["allCount"] : <any>null;
        }
    }

    static fromJS(data: any): ProductTypeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item.toJSON());
        }
        data["allCount"] = this.allCount !== undefined ? this.allCount : <any>null;
        return data;
    }
}

export interface IProductTypeOutputDto {
    productTypes?: ProductOutputDto[] | null;
    allCount: number;
}

export class ProductOutputDto implements IProductOutputDto {
    id!: number;
    name?: string | null;
    arabicName?: string | null;
    licenceType?: OutputIndexDto | null;
    dateCreated?: string | null;
    description?: string | null;
    arabicDescription?: string | null;
    activatedCount!: number;
    generatedCount!: number;
    autoSentLicenseKey!: boolean;
    brand?: OutputIndexDto | null;
    platform?: OutputIndexDto | null;
    howToActivate?: string | null;
    arabicHowToActivate?: string | null;
    key?: string | null;
    downloadUrl?: string | null;

    constructor(data?: IProductOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.arabicName = _data["arabicName"] !== undefined ? _data["arabicName"] : <any>null;
            this.licenceType = _data["licenceType"] ? OutputIndexDto.fromJS(_data["licenceType"]) : <any>null;
            this.dateCreated = _data["dateCreated"] !== undefined ? _data["dateCreated"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.arabicDescription = _data["arabicDescription"] !== undefined ? _data["arabicDescription"] : <any>null;
            this.activatedCount = _data["activatedCount"] !== undefined ? _data["activatedCount"] : <any>null;
            this.generatedCount = _data["generatedCount"] !== undefined ? _data["generatedCount"] : <any>null;
            this.autoSentLicenseKey = _data["autoSentLicenseKey"] !== undefined ? _data["autoSentLicenseKey"] : <any>null;
            this.brand = _data["brand"] ? OutputIndexDto.fromJS(_data["brand"]) : <any>null;
            this.platform = _data["platform"] ? OutputIndexDto.fromJS(_data["platform"]) : <any>null;
            this.howToActivate = _data["howToActivate"] !== undefined ? _data["howToActivate"] : <any>null;
            this.arabicHowToActivate = _data["arabicHowToActivate"] !== undefined ? _data["arabicHowToActivate"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.downloadUrl = _data["downloadUrl"] !== undefined ? _data["downloadUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ProductOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["arabicName"] = this.arabicName !== undefined ? this.arabicName : <any>null;
        data["licenceType"] = this.licenceType ? this.licenceType.toJSON() : <any>null;
        data["dateCreated"] = this.dateCreated !== undefined ? this.dateCreated : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["arabicDescription"] = this.arabicDescription !== undefined ? this.arabicDescription : <any>null;
        data["activatedCount"] = this.activatedCount !== undefined ? this.activatedCount : <any>null;
        data["generatedCount"] = this.generatedCount !== undefined ? this.generatedCount : <any>null;
        data["autoSentLicenseKey"] = this.autoSentLicenseKey !== undefined ? this.autoSentLicenseKey : <any>null;
        data["brand"] = this.brand ? this.brand.toJSON() : <any>null;
        data["platform"] = this.platform ? this.platform.toJSON() : <any>null;
        data["howToActivate"] = this.howToActivate !== undefined ? this.howToActivate : <any>null;
        data["arabicHowToActivate"] = this.arabicHowToActivate !== undefined ? this.arabicHowToActivate : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["downloadUrl"] = this.downloadUrl !== undefined ? this.downloadUrl : <any>null;
        return data;
    }
}

export interface IProductOutputDto {
    id: number;
    name?: string | null;
    arabicName?: string | null;
    licenceType?: OutputIndexDto | null;
    dateCreated?: string | null;
    description?: string | null;
    arabicDescription?: string | null;
    activatedCount: number;
    generatedCount: number;
    autoSentLicenseKey: boolean;
    brand?: OutputIndexDto | null;
    platform?: OutputIndexDto | null;
    howToActivate?: string | null;
    arabicHowToActivate?: string | null;
    key?: string | null;
    downloadUrl?: string | null;
}

export class OutputIndexDto implements IOutputIndexDto {
    name?: string | null;
    arabicName?: string | null;
    id!: number;

    constructor(data?: IOutputIndexDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.arabicName = _data["arabicName"] !== undefined ? _data["arabicName"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): OutputIndexDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutputIndexDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["arabicName"] = this.arabicName !== undefined ? this.arabicName : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IOutputIndexDto {
    name?: string | null;
    arabicName?: string | null;
    id: number;
}

export class ProductTypeInputDto implements IProductTypeInputDto {
    id?:number | null;
    name?: string | null;
    arabicName?: string | null;
    licenceTypeId!: number;
    brandId!: number;
    howToActivate?: string | null;
    arabicHowToActivate?: string | null;
    platformId!: number;
    userId?: string | null;
    description?: string | null;
    arabicDescription?: string | null;
    autoSentLicenseKey!: boolean;

    constructor(data?: IProductTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.arabicName = _data["arabicName"] !== undefined ? _data["arabicName"] : <any>null;
            this.licenceTypeId = _data["licenceTypeId"] !== undefined ? _data["licenceTypeId"] : <any>null;
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.howToActivate = _data["howToActivate"] !== undefined ? _data["howToActivate"] : <any>null;
            this.arabicHowToActivate = _data["arabicHowToActivate"] !== undefined ? _data["arabicHowToActivate"] : <any>null;
            this.platformId = _data["platformId"] !== undefined ? _data["platformId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.arabicDescription = _data["arabicDescription"] !== undefined ? _data["arabicDescription"] : <any>null;
            this.autoSentLicenseKey = _data["autoSentLicenseKey"] !== undefined ? _data["autoSentLicenseKey"] : <any>null;
        }
    }

    static fromJS(data: any): ProductTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["arabicName"] = this.arabicName !== undefined ? this.arabicName : <any>null;
        data["licenceTypeId"] = this.licenceTypeId !== undefined ? this.licenceTypeId : <any>null;
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["howToActivate"] = this.howToActivate !== undefined ? this.howToActivate : <any>null;
        data["arabicHowToActivate"] = this.arabicHowToActivate !== undefined ? this.arabicHowToActivate : <any>null;
        data["platformId"] = this.platformId !== undefined ? this.platformId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["arabicDescription"] = this.arabicDescription !== undefined ? this.arabicDescription : <any>null;
        data["autoSentLicenseKey"] = this.autoSentLicenseKey !== undefined ? this.autoSentLicenseKey : <any>null;
        return data;
    }
}

export interface IProductTypeInputDto {
    id?:number | null;
    name?: string | null;
    arabicName?: string | null;
    licenceTypeId: number;
    brandId: number;
    howToActivate?: string | null;
    arabicHowToActivate?: string | null;
    platformId: number;
    userId?: string | null;
    description?: string | null;
    arabicDescription?: string | null;
    autoSentLicenseKey: boolean;
}

export class QuestionOutputDto implements IQuestionOutputDto {
    id?: number | null;
    order?: number | null;
    active!: boolean;
    questionTitle?: string | null;
    arabicQuestionTitle?: string | null;
    answerContent?: string | null;
    arabicAnswerContent?: string | null;

    constructor(data?: IQuestionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.questionTitle = _data["questionTitle"] !== undefined ? _data["questionTitle"] : <any>null;
            this.arabicQuestionTitle = _data["arabicQuestionTitle"] !== undefined ? _data["arabicQuestionTitle"] : <any>null;
            this.answerContent = _data["answerContent"] !== undefined ? _data["answerContent"] : <any>null;
            this.arabicAnswerContent = _data["arabicAnswerContent"] !== undefined ? _data["arabicAnswerContent"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["questionTitle"] = this.questionTitle !== undefined ? this.questionTitle : <any>null;
        data["arabicQuestionTitle"] = this.arabicQuestionTitle !== undefined ? this.arabicQuestionTitle : <any>null;
        data["answerContent"] = this.answerContent !== undefined ? this.answerContent : <any>null;
        data["arabicAnswerContent"] = this.arabicAnswerContent !== undefined ? this.arabicAnswerContent : <any>null;
        return data;
    }
}

export interface IQuestionOutputDto {
    id?: number | null;
    order?: number | null;
    active: boolean;
    questionTitle?: string | null;
    arabicQuestionTitle?: string | null;
    answerContent?: string | null;
    arabicAnswerContent?: string | null;
}

export class Question extends AuditEntity implements IQuestion {
    order!: number;
    questionTitle?: string | null;
    arabicQuestionTitle?: string | null;
    answerContent?: string | null;
    arabicAnswerContent?: string | null;

    constructor(data?: IQuestion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.questionTitle = _data["questionTitle"] !== undefined ? _data["questionTitle"] : <any>null;
            this.arabicQuestionTitle = _data["arabicQuestionTitle"] !== undefined ? _data["arabicQuestionTitle"] : <any>null;
            this.answerContent = _data["answerContent"] !== undefined ? _data["answerContent"] : <any>null;
            this.arabicAnswerContent = _data["arabicAnswerContent"] !== undefined ? _data["arabicAnswerContent"] : <any>null;
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["questionTitle"] = this.questionTitle !== undefined ? this.questionTitle : <any>null;
        data["arabicQuestionTitle"] = this.arabicQuestionTitle !== undefined ? this.arabicQuestionTitle : <any>null;
        data["answerContent"] = this.answerContent !== undefined ? this.answerContent : <any>null;
        data["arabicAnswerContent"] = this.arabicAnswerContent !== undefined ? this.arabicAnswerContent : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IQuestion extends IAuditEntity {
    order: number;
    questionTitle?: string | null;
    arabicQuestionTitle?: string | null;
    answerContent?: string | null;
    arabicAnswerContent?: string | null;
}

export class QuestionInputDto implements IQuestionInputDto {
    id?: number | null;
    order?: number | null;
    questionTitle?: string | null;
    arabicQuestionTitle?: string | null;
    answerContent?: string | null;
    arabicAnswerContent?: string | null;
    userId?: string | null;

    constructor(data?: IQuestionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.questionTitle = _data["questionTitle"] !== undefined ? _data["questionTitle"] : <any>null;
            this.arabicQuestionTitle = _data["arabicQuestionTitle"] !== undefined ? _data["arabicQuestionTitle"] : <any>null;
            this.answerContent = _data["answerContent"] !== undefined ? _data["answerContent"] : <any>null;
            this.arabicAnswerContent = _data["arabicAnswerContent"] !== undefined ? _data["arabicAnswerContent"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["questionTitle"] = this.questionTitle !== undefined ? this.questionTitle : <any>null;
        data["arabicQuestionTitle"] = this.arabicQuestionTitle !== undefined ? this.arabicQuestionTitle : <any>null;
        data["answerContent"] = this.answerContent !== undefined ? this.answerContent : <any>null;
        data["arabicAnswerContent"] = this.arabicAnswerContent !== undefined ? this.arabicAnswerContent : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IQuestionInputDto {
    id?: number | null;
    order?: number | null;
    questionTitle?: string | null;
    arabicQuestionTitle?: string | null;
    answerContent?: string | null;
    arabicAnswerContent?: string | null;
    userId?: string | null;
}

export class RedeemCodeOutputDto implements IRedeemCodeOutputDto {
    redeemCodes?: CodeOutputDto[] | null;
    total!: number;
    allCount!: number;
    activatedCount!: number;
    waitingCount!: number;
    notActivatedCount!: number;

    constructor(data?: IRedeemCodeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["redeemCodes"])) {
                this.redeemCodes = [] as any;
                for (let item of _data["redeemCodes"])
                    this.redeemCodes!.push(CodeOutputDto.fromJS(item));
            }
            this.allCount = _data["allCount"] !== undefined ? _data["allCount"] : <any>null;
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.activatedCount = _data["activatedCount"] !== undefined ? _data["activatedCount"] : <any>null;
            this.waitingCount = _data["waitingCount"] !== undefined ? _data["waitingCount"] : <any>null;
            this.notActivatedCount = _data["notActivatedCount"] !== undefined ? _data["notActivatedCount"] : <any>null;
        }
    }

    static fromJS(data: any): RedeemCodeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemCodeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.redeemCodes)) {
            data["redeemCodes"] = [];
            for (let item of this.redeemCodes)
                data["redeemCodes"].push(item.toJSON());
        }
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["allCount"] = this.allCount !== undefined ? this.allCount : <any>null;
        data["activatedCount"] = this.activatedCount !== undefined ? this.activatedCount : <any>null;
        data["waitingCount"] = this.waitingCount !== undefined ? this.waitingCount : <any>null;
        data["notActivatedCount"] = this.notActivatedCount !== undefined ? this.notActivatedCount : <any>null;
        return data;
    }
}

export interface IRedeemCodeOutputDto {
    redeemCodes?: CodeOutputDto[] | null;
    total: number;
    allCount: number;
    activatedCount: number;
    waitingCount: number;
    notActivatedCount: number;
}

export class CodeOutputDto implements ICodeOutputDto {
    id!: number;
    code?: string | null;
    createdDate?: string | null;
    activatedDate?: string | null;
    status!: Status;
    strStatus?: string | null;
    productType?: OutputIndexDto | null;
    licenseType?: OutputIndexDto | null;
    customer?: OutputIndexDto | null;
    country?: string | null;
    email?: string | null;
    qrCode?:string | null;
    constructor(data?: ICodeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.createdDate = _data["createdDate"] !== undefined ? _data["createdDate"] : <any>null;
            this.activatedDate = _data["activatedDate"] !== undefined ? _data["activatedDate"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.strStatus = _data["strStatus"] !== undefined ? _data["strStatus"] : <any>null;
            this.productType = _data["productType"] ? OutputIndexDto.fromJS(_data["productType"]) : <any>null;
            this.licenseType = _data["licenseType"] ? OutputIndexDto.fromJS(_data["licenseType"]) : <any>null;
            this.customer = _data["customer"] ? OutputIndexDto.fromJS(_data["customer"]) : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.qrCode = _data["qrCode"] !== undefined ? _data["qrCode"] : <any>null;
        }
    }

    static fromJS(data: any): CodeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["createdDate"] = this.createdDate !== undefined ? this.createdDate : <any>null;
        data["activatedDate"] = this.activatedDate !== undefined ? this.activatedDate : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["strStatus"] = this.strStatus !== undefined ? this.strStatus : <any>null;
        data["productType"] = this.productType ? this.productType.toJSON() : <any>null;
        data["licenseType"] = this.licenseType ? this.licenseType.toJSON() : <any>null;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["qrCode"] = this.qrCode !== undefined ? this.qrCode : <any>null;
        return data;
    }
}

export interface ICodeOutputDto {
    id: number;
    code?: string | null;
    createdDate?: string | null;
    activatedDate?: string | null;
    status: Status;
    strStatus?: string | null;
    productType?: OutputIndexDto | null;
    licenseType?: OutputIndexDto | null;
    customer?: OutputIndexDto | null;
    country?: string | null;
    email?: string | null;
    qrCode?: string | null;
}

export class RedeemCodeFilterDto implements IRedeemCodeFilterDto {
    key?: string | null;
    fromDate?: Date | null;
    toDate?: Date | null;
    typeId?: string | null;
    country?: string | null;
    status?: number | null;
    count?:number | null;
    skip?:number | null;
    constructor(data?: IRedeemCodeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] ? new Date(_data["key"].toString()) : <any>null;
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>null;
            this.count = _data["count"] ? _data["count"] : <any>null;
            this.skip = _data["skip"] ? _data["skip"] : <any>null;
            this.typeId = _data["typeId"] !== undefined ? _data["typeId"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): RedeemCodeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemCodeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key ? this.key : <any>null;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        data["typeId"] = this.typeId !== undefined ? this.typeId : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["skip"] = this.skip !== undefined ? this.skip : <any>null;
        return data;
    }
}

export interface IRedeemCodeFilterDto {
    key?: string | null;
    fromDate?: Date | null;
    toDate?: Date | null;
    typeId?: string | null;
    country?: string | null;
    status?: number | null;
    count?: number | null;
    skip?: number | null;
}

export class CustomerCodeOutputDto implements ICustomerCodeOutputDto {
    customer?: Customer | null;
    expand!: boolean;
    redeemCodes?: CodeOutputDto[] | null;

    constructor(data?: ICustomerCodeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>null;
            this.expand = _data["expand"] !== undefined ? _data["expand"] : <any>null;
            if (Array.isArray(_data["redeemCodes"])) {
                this.redeemCodes = [] as any;
                for (let item of _data["redeemCodes"])
                    this.redeemCodes!.push(CodeOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerCodeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCodeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>null;
        data["expand"] = this.expand !== undefined ? this.expand : <any>null;
        if (Array.isArray(this.redeemCodes)) {
            data["redeemCodes"] = [];
            for (let item of this.redeemCodes)
                data["redeemCodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerCodeOutputDto {
    customer?: Customer | null;
    expand: boolean;
    redeemCodes?: CodeOutputDto[] | null;
}
export class TemporaryInputDto implements ITemporaryInputDto {
    code?: string | null;
    fullName?: string | null;
    email?: string | null;

    constructor(data?: ITemporaryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): TemporaryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporaryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface ITemporaryInputDto {
    code?: string | null;
    fullName?: string | null;
    email?: string | null;
}

export class CheckInputDto implements ICheckInputDto {
    code?: string | null;
    userId?: string | null;
    language?: string | null;
    email?: string | null;

    constructor(data?: ICheckInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): CheckInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface ICheckInputDto {
    code?: string | null;
    userId?: string | null;
    language?: string | null;
    email?: string | null;
}

export class CodeInputDto implements ICodeInputDto {
    count!: number;
    typeId!: number;
    userId?: string | null;

    constructor(data?: ICodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.typeId = _data["typeId"] !== undefined ? _data["typeId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): CodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["typeId"] = this.typeId !== undefined ? this.typeId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface ICodeInputDto {
    count: number;
    typeId: number;
    userId?: string | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}